<template>
  <NuxtPage />
</template>

<script lang="ts" setup>
import { useCatcher } from './useCatcher'

useCatcher()
</script>
